module.exports = __webpack_public_path__ + "static/img/dropper.cef7f1b2.png";